export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE';
export const ADD_ERROR = 'ADD_ERROR';
export const REMOVE_ERROR = 'REMOVE_ERROR';

export function addError(error) {

  let errorMessage = 'Something bad happened';

  if (typeof error === 'string') {
    errorMessage = error;
  } else if (error && error.message){
    errorMessage = error.message
  } else if (error === null) {
    errorMessage = 'Please log in';
  }

  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      return resolve(dispatch({
        type: ADD_ERROR,
        error: true,
        payload: errorMessage
      }));
    });
  };
}

export function resetError() {
  return {
    type: RESET_ERROR_MESSAGE,
    error: false
  };
}